import { GenIcon } from '../helpers/IconBase.es.js';

const ChevronUpFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 512 512", fill: "none" },
    child: [
      {
        tag: "polyline",
        attr: {
          points: "112 328 256 184 400 328",
          strokeWidth: "48px",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#000"
        }
      }
    ]
  })(props);
};

export { ChevronUpFilled };
